/**
 * Convert a value from meters to a metric unit (milimeter, centimeter, kilometer)
 *
 * @param value value to convert
 * @param unit unit to convert to (Meter is the default)
 * @returns the value converted to the specified unit (Meter is the default)
 */
export const meterToMetric = (value: number, unit: string = 'meter'): number => {
  if (unit === 'meter') {
    return value;
  }
  switch (unit) {
    case 'milimeter':
      return value * 1000;
    case 'centimeter':
      return value * 100;
    case 'kilometer':
      return value / 1000;
    default:
      throw new Error('Invalid metric unit');
  }
};
